import { Grid, Typography, } from "@mui/material";

import SampleReportsOverviewFormTable from "./PrimaryContactOverviewFormTable";
import useFetch from "../../../hooks/useFetch";
import { useEffect, useRef, useState } from "react";
import { FLEET_APIS, MASTER_DATA_APIS } from "../../../common/apis";

export default function PrimaryContactOverview({
  formData,
  rowDataProps,
  setOpenDialog,
}) {
  const { get, post } = useFetch();

  const [primaryContactData, setPrimaryContactData] = useState([]);
  const [localData, setLocalData] = useState({});
  const [infoObj, setInfoObj] = useState({ message: "", color: "black" });
  const didRun = useRef(false);

  function rowSelectedHandler(rowData) {
    rowDataProps && rowDataProps(rowData);
  }

  const getSites = async (custId) => {
    const sites = await get(`${MASTER_DATA_APIS.SITES}?custId=${custId}`);
    var str = "";
    if (sites?.length > 0) {
      const nopc = sites.filter(s => s.HasPrimaryContacts == false)?.length;
      const pc = sites.filter(s => s.HasPrimaryContacts == true)?.length;
      if (nopc == 0) {
        str = "The customer has primary contact(s) across " + (sites?.length != 1 ? "all " + sites?.length + " sites" : "the single site");
        setInfoObj({ message: str });
      }
      else {
        str = "The customer has primary contact(s) only across " + pc + " of " + sites?.length + " sites";
        setInfoObj({ message: str });
      }
    }
    else {
      str = "The customer sites have primary contact(s)";
      setInfoObj({ message: str });
    }
  }

  const getPrimaryContacts = async (lData) => {
    let resData = await post(FLEET_APIS.CONTACTS_FOR_PRIMARY, {
      SampleNumber: lData?.SampleNumber,
      CustomerId: lData?.CustomerId,
      SiteId: lData?.SiteId,
      UnitId: lData?.UnitId,
      ReportNumber: lData?.ReportNumber,
      ContactId: lData?.ContactId,
      ProductId: lData?.ProductId,
      SiteSetId: lData?.SiteSetId,
      ParentId: lData?.ParentId,
      ComponentId: lData?.ComponentId,
    });

    setPrimaryContactData(resData);
    if ((lData?.Customer?.length < 1 || lData?.Customer === undefined) && resData?.length > 0) {
      document.title = "Primary Contacts Overview - " + (resData[0]?.Company || "");
    }
    // localStorage.removeItem("primary-contacts-overview");
    if (((lData?.CustomerId > 0)) && !(lData?.SiteId > 0)) {
      getSites(lData?.CustomerId)
    }
    else {
      var str = "The site has " + resData?.length + " primary contact(s)";
      setInfoObj({ message: str });
    }
  }

  useEffect(() => {
    if (didRun.current) return;
    didRun.current = true;
    (async function () {
      let parseData = {};
      let formDatas = localStorage.getItem("primary-contacts-overview")
      if (formDatas !== null && formDatas !== "null" && formDatas !== undefined) {
        parseData = JSON.parse(formDatas)
        setLocalData(parseData);
        document.title = "Primary Contacts Overview - " + (parseData?.Customer || "");
      }

      await getPrimaryContacts(formData || parseData);

    })();
  }, [formData?.SampleNumber]);

  const handleCloseButton = () => {
    localStorage.removeItem("primary-contacts-overview");
  }

  useEffect(function () {
    window.addEventListener("beforeunload", handleCloseButton);
    return function () {
      window.removeEventListener("beforeunload", handleCloseButton);
    };
  });


  return (
    <>
      <Grid container spacing={2} sx={{ minWidth: "90vw" }}>
        <Grid item xs={12}>
          <Typography>{infoObj?.message || ""}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle2">
            Total Records:{" "}
            <b> {primaryContactData && primaryContactData.length}</b>
          </Typography>
          <SampleReportsOverviewFormTable
            setOpenDialog={setOpenDialog}
            data={primaryContactData}
            rowSelected={rowSelectedHandler}
            localData={localData}
            getPrimaryContacts={getPrimaryContacts}
          />
        </Grid>
      </Grid>
    </>
  );
}
